import type { PresentationIsEmptyProps } from '../../'
export default function isEmpty({ block }: PresentationIsEmptyProps) {
  const fields = block?.fields
  if (!fields) {
    return true
  }

  if (!fields.label || !fields.href) {
    return true
  }

  return false
}
